import React, { useRef, useEffect } from "react";
import "react-slidedown/lib/slidedown.css";
import "./MobileMenu.scoped.scss";
import useStore from "core/custom-hooks/useStore";
import useSiteStructure from "core/custom-hooks/useSiteStructure";
import SidebarSection from "../Sidebar/SidebarSection/SidebarSection";
import { setIsMobileMenuOpen } from "core/store/actionCreators";
import useOutsideClick from "core/custom-hooks/useOutsideClick";
import * as Utils from "core/common/utils";
import clsx from "clsx";

const MobileMenu = () => {
    const { dispatch, state } = useStore();
    const { isMobileMenuOpen, isMobile } = state;
    const { getSiteStructure } = useSiteStructure();
    const siteStructure = getSiteStructure();

    const ref = useRef();
    useOutsideClick(ref, () => isMobileMenuOpen && dispatch(setIsMobileMenuOpen(false)));

    const handleWindowResize = () => {
        if (isMobileMenuOpen && Utils.isDesktop()) {
            dispatch(setIsMobileMenuOpen(false));
        }
    };
    useEffect(() => {
        window.addEventListener("resize", handleWindowResize);
        return () => { window.removeEventListener("resize", handleWindowResize, true); };
    }, []);

    if (!isMobile) return null;
    return (
        <div ref={ref} className="side_bar_area">
            <div className={clsx("side_bar_wrap", "side_bar_animation-close", isMobileMenuOpen && "side_bar_animation")}>
                <div className="side_bar_max">
                    <div className="side_bar_menu_wrap on_scrolling">
                        <ul className="side_bar_menu_list">
                            {
                                siteStructure
                                    .map((x, index) =>
                                        <SidebarSection key={`Sidebar_SidebarSection_${index}`} {...x} isMobileMenu={true} />)
                            }
                        </ul>
                        <div className="side_bar_footer">
                            <a href="https://img.zapgroup.co.il/PrivacyPolicy.pdf" target="_blank" rel="noopener noreferrer">
                                מדיניות הפרטיות
                            </a>
                            <a href="https://zapgroup.co.il/terms/" target="_blank" rel="noopener noreferrer">
                                תנאי שימוש
                            </a>
                        </div>
                    </div>
                </div>

                <div className="side_close_icon">
                    <a
                        role="button"
                        href="/"
                        className="side_close_btn"
                        onClick={(e) => {
                            e.preventDefault();
                            dispatch(setIsMobileMenuOpen(false));
                        }}>
                        <i className="fa ion-android-close"></i>
                    </a>
                </div>
            </div>
        </div>
    );
}

export default MobileMenu;